module.exports = __webpack_public_path__ + "static/img/product_images_25_h5_zh.dc93f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_25_h5_zh.png
// module id = VfYJ
// module chunks = 34